import dimensions from '../../../utils/dimensions'
import isServer from '../../../utils/is-server'

const carouselConfig = {
  DRAG_OFFSET_THRESHOLD: !isServer() ? dimensions.vw(30) : 150,
  DRAG_VELOCITY_THRESHOLD: !isServer() ? dimensions.vw(125) : 400,
}

export default carouselConfig
